export default "__VITE_ASSET__Cd9l9P$e__"